<template>
  <main class="main-container">
    <div class="k-onboarding__quest-wrapper">
      <div class="k-onboarding__quest">
        <div class="k-onboarding__title mb-1">Регистрация</div>
        <p class="k-onboarding__subtitle k-onboarding__subtitle--low">Зарегистрируйтесь, чтобы получить доступ к рецептам</p>
        <div class="k-registration__input-wrapper">
          <input
            :class="['k-registration__input k-registration__name-input jq-onboarding-input', {'has-error': !!errors.name}]"
            type="email"
            placeholder="Имя"
            title="Name"
            id="registration_name"
            :value="form.name"
            @input="capitalizeFirst"
            @keydown="clearError('name')"
            v-focus
            required
          />
        </div>
        <div
          v-if="errors.name"
          class="error-message"
        >{{errors.name}}</div>

        <div class="k-registration__input-wrapper">
          <input
            :class="['k-registration__input k-registration__email-input jq-onboarding-input', {'has-error': !!errors.email}]"
            type="email"
            placeholder="E-mail"
            title="E-mail"
            id="registration_email"
            v-model="form.email"
            @keydown="clearError('email')"
            @change="validateEmail"
            required
          />
        </div>
        <div v-if="errors.email" class="error-message">{{errors.email}}</div>

        <div class="k-registration__input-wrapper">
          <input
            :class="['k-registration__input k-registration__email-input jq-onboarding-input', {'has-error': !!errors.password}]"
            type="password"
            placeholder="Пароль"
            title="Пароль"
            id="registration_password"
            v-model="form.password"
            @keydown="clearError('password')"
            @blur="validatePassword()"
            required
          />
        </div>
        <div v-if="errors.password" class="error-message">{{errors.password}}</div>

        <div class="k-registration__input-wrapper">
          <input
            :class="['k-registration__input k-registration__email-input jq-onboarding-input', {'has-error': !!errors.password_confirmation}]"
            type="password"
            placeholder="Подтверждение пароля"
            title="Подтверждение пароля"
            id="registration_password_confirmation"
            v-model="form.password_confirmation"
            @keydown="clearError('password_confirmation')"
            @blur="validatePassword()"
            required
          />
        </div>
        <div v-if="errors.password_confirmation" class="error-message">{{errors.password_confirmation}}</div>

        <div class="d-flex align-items-center k-registration__accept-text mt-2" @click="accepted = !accepted">
          <div class="k-ingredient-card__select" :class="{ active: accepted }">
            <svg width="16" height="12" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 3.52308L3.21429 5L6.5 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="k-registration-text m-0">Я ознакомился с <a href="https://online-kitchen.ru/dogovor-oferty" target="_blank">Политикой конфиденциальности</a> и <a href="https://online-kitchen.ru/dogovor-oferty" target="_blank">правилами Публичной оферты</a> и принимаю их</div>
        </div>

        <a
          href="#"
          :class="['k-onboarding__quest-next', {'active': canRegister && accepted}]"
          @click.prevent="register"
        >Далее</a>
        <router-link to="/login" class="k-orange-link p-2">Уже есть аккаунт</router-link>
      </div>
    </div>
  </main>
</template>

<script>
import userApi from "@/api/UserApi";
import { mapActions } from 'vuex';
export default {
  name: "Registration",
  data: function() {
    return {
      form: {
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
      },
      errors: {
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
      },
      accepted: false
    };
  },
  computed: {
    canRegister: function() {
      for (let k in this.form) {
        if (!this.form[k]) {
          return false;
        }
      }
      for (let errorKeys in this.errors) {
        if (this.errors[errorKeys]) {
          return false;
        }
      }
      if (this.form.password !== this.form.password_confirmation) {
        return false;
      }
      return true;
    }
  },
  methods: {
    ...mapActions([
      'loadUser',
    ]),

    capitalizeFirst(evt) {
      const value = evt.target.value;
      this.form.name = value.charAt(0).toUpperCase() + value.slice(1)
    },
    validatePassword() {
      if (!!this.form.password && !!this.form.password_confirmation && this.form.password !== this.form.password_confirmation) {
        this.errors.password_confirmation = 'Пароли не совпадают.'
      }
    },

    clearError(field) {
      this.errors[field] = null;
    },

    validateEmail() {
      if (!this.form.email) {
        this.errors.email = "Поле E-mail обязательно для заполнения.";
      } else if (!/(.+)@(.+){2,}\.(.+){2,}/.test(this.form.email)) {
        this.errors.email = "Неверный формат поля E-mail.";
      }
    },

    /**
     * Register user
     */
    async register() {
      if (!this.canRegister) {
        return;
      }

      this.form.settings = JSON.stringify({
        show_boughted_ingredients: false,
        show_boughted_recipes: false,
      })

      const process = async data => {
        console.log('data')
        if (!data.success) {
          for (let key in data.errors) {
            if (typeof this.errors[key] !== "undefined") {
              this.errors[key] = data.errors[key];
            }
          }
        } else {
          userApi.prefetch();
          this.$store.commit("setUser", data.data.user);

          await this.loadUser();

          this.$router.push({ name: 'Onboarding' });
        }
      }

      try {
        const {data} = await userApi.register(this.form);
        await process(data);

      } catch (e) {
        console.error("Error during registration: ", e)

        // location.reload();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.k-registration__notify-text {
  color: #a0a0a0;
  font-size: 12px;
  line-height: 18px;
}

.k-ingredient-card__select {
  border: 1px solid #F7981E;
  box-sizing: border-box;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-width: 28px;
  height: 28px;
  margin-right: 5px;

  svg {
    display: none;
    width: 17px;
    height: 13px;
  }

  &.active {
    background: #F7981E;
    svg {
      display: block;
    }
  }
}
.k-registration__accept-text {
  font-size: 12px;
  color: #A0A0A0;
  position: relative;

  .k-ingredient-card__select {
    position: absolute;
    left: -15px;
    top: 50%;
    transform: translate(-100%, -50%);
  }

  a {
    color: #F68C1E;
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
  }

  .k-registration-text {
    max-width: 260px;
    display: block;
  }

  @media screen and (max-width: 345px) {
    .k-ingredient-card__select {
      position: relative;
      transform: unset;;
    }
  }
}
</style>
